/* eslint-disable consistent-return */
/* eslint-disable no-unneeded-ternary */
/* eslint-disable no-underscore-dangle */
/* eslint-disable prettier/prettier */
/* eslint-disable arrow-body-style */
import React from 'react';
import { Box } from '@mui/material';
import EngagementCard from './EngagementCard';
import useAuth from 'hooks/useAuth';

const EngagementList = ({ tweets, forUser }) => {
    const { likedTweet, setLikedTweet, repliedTweet, setRepliedTweet, twitter, skippedTweet, setSkippedTweet } = useAuth();

    return (
        <Box>

            {/* {tweets.filter(tweet => skippedTweet.indexOf(tweet.tweetIDSTR)  -1).map(tweet => { */}
            {tweets.map(tweet => {
                const found = likedTweet.find(likedTweet => likedTweet.likedTweetID === tweet.tweetIDSTR)
                const replyed = repliedTweet.find(repliedTweet => repliedTweet === tweet.tweetIDSTR)
                // console.log('skip check: ', skippedTweet.indexOf(tweet.tweetIDSTR))
                if (skippedTweet?.indexOf(tweet.tweetIDSTR) !== -1) return;

                // console.log(replyed)


                // eslint-disable-next-line no-unneeded-ternary
                return <EngagementCard
                    key={tweet._id}
                    tweet={tweet}
                    liked={found ? true : false}
                    setLikedTweet={setLikedTweet}
                    replyed={replyed ? true : false}
                    setRepliedTweet={setRepliedTweet}
                    forUser
                    uid={twitter?.uid}
                    setSkippedTweet={setSkippedTweet}
                />
            })}

        </Box>
    );
};

export default EngagementList;